import { render, staticRenderFns } from "./CadUsuario.vue?vue&type=template&id=ca3cfbb2&"
import script from "./CadUsuario.vue?vue&type=script&lang=js&"
export * from "./CadUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports